import React from 'react';

import styled from '@emotion/styled';

import { HistoryBackButton } from 'components/elements/BackButton';

const SectionWrapperBox = styled.div<{ $fillHeight?: boolean }>`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;

  ${({ $fillHeight }) => $fillHeight && `
    flex: 1;
    height: 100%;
    min-height: 0;
    overflow: hidden;
  `}
`;

const SectionBody = styled.div<{ $fillHeight?: boolean }>`
  ${({ $fillHeight }) => $fillHeight && `
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  `}
`;

const SectionHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const SectionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const SectionTitle = styled.h1`
  margin-bottom: 1rem;
  padding: 0;
  font-size: 1.5rem;
`;

interface SectionWrapperProps {
  backButton?: React.ReactNode;
  children: React.ReactNode;
  fillHeight?: boolean;
  goBack?: boolean;
  menu?: React.ReactNode;
  title?: string;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({
  backButton, children, fillHeight, goBack, menu, title,
}) => {
  const renderBackButton = backButton ?? (goBack ? <HistoryBackButton /> : null);

  return (
    <SectionWrapperBox $fillHeight={fillHeight}>
      {(renderBackButton || title || menu) && (
        <SectionHeader>
          <SectionTitleWrapper>
            {renderBackButton}
            {title && <SectionTitle>{title}</SectionTitle>}
          </SectionTitleWrapper>
          {menu}
        </SectionHeader>
      )}
      {fillHeight ? (
        <SectionBody $fillHeight={fillHeight}>{children}</SectionBody>
      ) : (
        children
      )}
    </SectionWrapperBox>
  );
};

export default SectionWrapper;
